import objectPath from 'object-path'
import { renderRefreshTable } from './Table'
import { getCheckValue, getCurrentUi } from './Data'
import { isExternalApiUrl, ROUTE_API, ROUTE_HIS } from './Config'
import { createDesignerData } from './Design'

export const getPath = (path, action, urlParams) => {
  const { perspectiveRoute = '' } = action
  let perspective = ''
  if (perspectiveRoute === '') {
    if (objectPath.has(urlParams, 0)) {
      perspective = urlParams[0]
    } else if (objectPath.has(urlParams, 'perspective')) {
      perspective = urlParams.perspective
    }
  } else {
    perspective = perspectiveRoute
  }
  if (perspective.startsWith('/#')) {
    perspective = perspective.replace('/#', '')
  }
  if (perspective.startsWith('/')) {
    path = `${perspective}${path}`
  } else if (perspective) {
    path = `/${perspective}${path}`
  } else {
    path = `/designer${path}`
  }
  return path
}

const pushHistory = (
  action,
  designContext,
  path,
  routerDom,
  locationSearch = '',
) => {
  let { history } = routerDom
  let { jsonForm, setFormData, urlParams = {} } = designContext
  let formData = objectPath.get(jsonForm, 'formData')
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  path = getPath(path, action, urlParams)

  let queryString = []
  if (action.routerDomParams) {
    let routerDomParams = action.routerDomParams
    routerDomParams.forEach(({ param, paramType, key, value }) => {
      let paramValue
      if (paramType === 'input') {
        paramValue = formData[key]
      } else if (paramType === 'condition') {
        paramValue = value
      } else if (paramType === 'datasource') {
        paramValue = objectPath.get(datasourceValue, value)
      } else if (paramType === 'urlParam') {
        paramValue = objectPath.get(urlParams, value)
      }
      if (paramValue !== null && paramValue !== undefined) {
        queryString.push(`${param}=${paramValue}`)
      }
    })
  }
  let historyData = {
    pathname: path,
    search: locationSearch ?? '?' + queryString.join('&'),
  }
  if (action.props) {
    let propList = action.props
    propList.map((prop) => {
      if (prop.propType === 'input' && prop.key) {
        let value = formData[prop.key]
        prop.value = value
      }
      if (prop.propType === 'formData' && formData.props) {
        let value = formData.props[prop.prop]
        prop.value = value
      }

      return prop
    })
    let pageCode = objectPath.set(jsonForm, 'props.system.props.pageCode.value')
    if (pageCode) {
      propList.push({
        prop: 'pageCode',
        propType: 'system',
        value: pageCode,
      })
    }

    historyData.state = propList
  } else {
    historyData.state = null
    setFormData({})
  }
  if (action?.openNewTab) {
    let path = historyData.pathname + historyData.search
    window.open(ROUTE_HIS + path, '_blank')
  } else {
    history.push(historyData)
  }

  return { status: 200 }
}

export const goToForm = (action, designContext, routerDom) => {
  if (!action.formCode) return
  let path = `/display/form/${action.formCode}`
  return pushHistory(action, designContext, path, routerDom)
}

export const goToPage = (action, designContext, routerDom) => {
  let { location } = routerDom
  let state = location.state || []
  let formCode = action.formCode
  let pageProp = state.find(
    (item) => item.prop === 'pageCode' && item.propType === 'system',
  )
  if (action.sourceType === 'pageCode') {
    formCode = pageProp?.value || ''
  }
  if (!formCode) return
  let path = `/display/page/${formCode}`
  return pushHistory(action, designContext, path, routerDom)
}

export const goToUrl = (action, designContext, data) => {
  let {
    url = '',
    linkType = '',
    pagePath = '',
    pathParams = [],
    queryParams = [],
    openNewTab = false,
  } = action

  let { jsonForm } = designContext
  let formData = objectPath.get(jsonForm, 'formData')
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  let { allParams } = data

  if (linkType === 'internal') {
    url = pagePath
  } else if (linkType === 'api') {
    let { apiType, service = '', endpoint = '', api = '' } = action
    url = apiType === 'internal' ? service + endpoint : api
  }
  if (pathParams) {
    pathParams.forEach(({ param, propType, key, value, sourceKey }) => {
      let paramValue
      if (propType === 'datasource') {
        paramValue = objectPath.get(datasourceValue, `${sourceKey}.${key}`)
      } else if (propType === 'urlParam') {
        paramValue = objectPath.get(allParams, key)
      } else if (propType === 'input') {
        paramValue = objectPath.get(formData, key)
      } else {
        paramValue = value
      }
      url = url.replace(`:${param}`, paramValue)
    })
  }
  if (queryParams) {
    let queryString = []
    queryParams.forEach(({ param, propType, key, value, sourceKey }) => {
      let paramValue
      if (propType === 'datasource') {
        paramValue = objectPath.get(datasourceValue, `${sourceKey}.${key}`)
      } else if (propType === 'urlParam') {
        paramValue = objectPath.get(allParams, key)
      } else if (propType === 'input') {
        paramValue = objectPath.get(formData, key)
      } else {
        paramValue = value
      }
      if (paramValue !== null && paramValue !== undefined) {
        queryString.push(`${param}=${paramValue}`)
      }
    })
    if (queryString.length > 0) {
      let connect = url.indexOf('?') > -1 ? '&' : '?'
      url = url ? url + connect + queryString.join('&') : url
    }
  }
  let target = openNewTab ? '_blank' : '_self'
  if (linkType === 'api') {
    if (url.startsWith('/')) {
      window.open(ROUTE_API + url, target)
    } else {
      window.open(`${ROUTE_API}/` + url, target)
    }
  } else if (isExternalApiUrl(linkType, url)) {
    window.open(url, target)
  } else if (url.startsWith('http')) {
    window.open(url, target)
  } else if (url.startsWith('/')) {
    window.open(ROUTE_HIS + url, target)
  } else {
    window.open(`${ROUTE_HIS}/` + url, target)
  }
  return { status: 200 }
}

export const goToDesigner = (action, designContext, routerDom) => {
  if (!action.formCode) return
  let path = `/${action.sourceType}/${action.formCode}`
  let { location } = routerDom
  let locationSearch = location.search
  return pushHistory(
    { ...action, openNewTab: true },
    designContext,
    path,
    routerDom,
    locationSearch,
  )
}

const getModal = (form, modalKey, designContext) => {
  let { findUischemaIndex } = designContext
  let elements = form.uischema.elements
  let mapKey = form.schema.mapKey[modalKey]
  let indices = findUischemaIndex(modalKey, mapKey, elements)
  let modalElement = indices.reduce((o, i) => o.elements[i], { elements })
  return modalElement
}

export const openModal = async (action, designContext, data) => {
  let {
    jsonForm,
    searchData,
    setUischema,
    setOpenModal,
    setDesignerPropsData,
  } = designContext
  let formData = objectPath.get(jsonForm, 'formData')
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  let { designerKey } = data
  let { formId } = action
  if (formId) {
    objectPath.set(formData, `@condition.${formId}`, {})
  }
  let modalKey = objectPath.get(action, 'modal.key')
  if (action.modalType === 'internal') {
    let elements = jsonForm.uischema.elements
    let modalElement = getModal(jsonForm, modalKey, designContext)
    modalElement.isOpen = true
    let newUiSchema = jsonForm.uischema
    newUiSchema.elements = elements
    setUischema(newUiSchema)
    setOpenModal(action.modal)
  } else if (action.modalType === 'external') {
    objectPath.set(designerPropsData, 'modal', action.formCode)
    designerPropsData = createDesignerData(
      designerPropsData,
      searchData,
      formData,
    )
    setDesignerPropsData(designerPropsData)
    setOpenModal(designerKey)
  } else if (action.modalType === 'component') {
    objectPath.set(designerPropsData, 'modal', action.component)
    designerPropsData = createDesignerData(
      designerPropsData,
      searchData,
      formData,
    )
    setOpenModal(designerKey)
    setDesignerPropsData(designerPropsData)
  } else if (action.modalType === 'assessment') {
    objectPath.set(designerPropsData, 'modal', action.assessmentCode)
    designerPropsData = createDesignerData(
      designerPropsData,
      searchData,
      formData,
    )
    setOpenModal(designerKey)
    setDesignerPropsData(designerPropsData)
  }
  return { status: 200 }
}

const createComponentPropsData = (sendProps, action, designContext) => {
  let { jsonForm, setComponentPropsData } = designContext
  let datasourceValue = objectPath.get(designContext, `@datasource`) || {}
  let formData = objectPath.get(jsonForm, 'formData')
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  let designerData = objectPath.get(designerPropsData, 'data') || {}
  let componentPropsData = {
    data: formData,
    isClosed: true,
    send: sendProps,
    receive: designerPropsData.receive,
    isRefreshTable: action?.isRefreshTable,
  }
  let formGroup = jsonForm.formGroup || []
  const getSendPropValue = ({ key, prop, fullPropKey, jsonKey }) => {
    let value
    let keys = [
      key,
      prop,
      fullPropKey,
      jsonKey,
      key ? `@sendData.${key}` : '',
      prop ? `@sendData.${prop}` : '',
      fullPropKey ? `@sendData.${fullPropKey}` : '',
      jsonKey ? `@sendData.${jsonKey}` : '',
    ].filter((item) => item)

    keys.find((item) => {
      if (objectPath.has(formData, item)) {
        value = objectPath.get(formData, item)
        return true
      }
      if (objectPath.has(designerData, item)) {
        value = objectPath.get(designerData, item)
        return true
      }

      return false
    })

    return value
  }

  sendProps.forEach((sendProp = {}) => {
    let { key, prop, propType, dynamicName } = sendProp
    if (propType === 'input') {
      let value = getSendPropValue(sendProp)
      objectPath.set(componentPropsData, `data.${prop}`, value)
    } else if (propType === 'condition') {
      objectPath.set(componentPropsData, `data.${prop}`, 1)
    } else if (propType === 'formData') {
      let { json } = formGroup.find((form) => form.key === key) || {}
      if (json) {
        Object.keys(json).forEach((itemKey) => {
          let value = objectPath.get(formData, itemKey)
          objectPath.set(componentPropsData, `data.${prop}.${itemKey}`, value)
        })
      } else {
        let value = getSendPropValue(sendProp)
        objectPath.set(componentPropsData, `data.${prop}`, value)
      }
    } else if (propType === 'datasource') {
      let value = objectPath.get(datasourceValue, dynamicName)
      objectPath.set(componentPropsData, `data.${prop}`, value)
    } else {
      let value = getSendPropValue(sendProp)
      objectPath.set(componentPropsData, `data.${prop}`, value)
    }
  })
  objectPath.set(componentPropsData, 'rowData', null)
  setComponentPropsData(componentPropsData)
}

export const closeModal = async (action, designContext, data) => {
  let { jsonForm, setUischema, setOpenModal } = designContext
  let formData = objectPath.get(jsonForm, 'formData')

  if (action.modalType === 'internal') {
    let modalKey = objectPath.get(action, 'modal.key')
    if (!modalKey) return
    let elements = jsonForm.uischema.elements
    let modalElement = getModal(jsonForm, modalKey, designContext)
    modalElement.isOpen = false
    let newUiSchema = jsonForm.uischema
    newUiSchema.elements = elements
    setUischema(newUiSchema)
    setOpenModal(null)
  } else if (
    action.modalType === 'external' ||
    action.modalType === 'component'
  ) {
    let sendProps = objectPath.get(action, 'props') || []
    sendProps = typeof sendProps ? Object.values(sendProps) : sendProps
    createComponentPropsData(sendProps, action, designContext)
  }
  return { status: 200, data: formData, message: 'success' }
}

export const refreshTable = async (action, designContext, data) => {
  let {
    jsonForm,
    searchData,
    tabParamActive,
    setFormData,
    setComponentPropsData,
    setTableRefresh,
  } = designContext
  let schema = jsonForm.schema
  let tableList = action?.table || []
  const componentPropsData = objectPath.get(jsonForm, 'componentPropsData')
  let onAction = {
    setLoading: () => {},
    setPage: () => {},
    setRowsPerPage: () => {},
    setTotalCount: () => {},
    setTableColumn: () => {},
    setTableData: () => {},
    setComponentPropsData: setComponentPropsData,
    setFormData: setFormData,
  }
  let propTable = {
    ...data,
    formData: { ...jsonForm.formData, ...searchData },
    tabParamActive: tabParamActive,
    componentPropsData: componentPropsData,
    search: jsonForm.search,
    dynamicData: {},
    onAction: onAction,
    designContext,
  }
  tableList.forEach(async (tableKey) => {
    let uischema
    let isWidget = objectPath.has(schema, `mapWidget.ui.${tableKey}`)
    if (isWidget) {
      uischema = objectPath.get(schema, `mapWidget.ui.${tableKey}`)
    } else {
      uischema = getCurrentUi(tableKey, jsonForm.schema, jsonForm.uischema)
    }
    objectPath.set(propTable, 'uischema', uischema)
    objectPath.set(propTable, 'pagination.page', 0)
    objectPath.set(propTable, 'pagination.rowsPerPage', uischema.rowsPerPage)
    renderRefreshTable(propTable).then((tableData) => {
      setTableRefresh([{ key: tableKey, isButton: true, data: tableData }])
    })
  })
  return {
    status: 200,
    message: 'success',
    data: {},
  }
}

export const print = (action, designContext) => {
  let { jsonForm } = designContext
  let formData = objectPath.get(jsonForm, 'formData')
  let url = objectPath.get(action, 'print.url') || ''
  let pathParams = objectPath.get(action, 'print.pathParams')
  let queryParams = objectPath.get(action, 'print.queryParams')
  const findCheckboxGroup = (key, elements = []) => {
    let checkboxGroup = null
    elements.some((ui = {}) => {
      if (ui.tagname === 'checkboxGroup' && ui.key === key) {
        checkboxGroup = ui
        return true
      }
      if (ui.elements) {
        checkboxGroup = findCheckboxGroup(key, ui.elements)
        return !!checkboxGroup
      }
      return false
    })
    return checkboxGroup
  }

  const findCheckbox = (key, elements = []) => {
    let checkbox = null
    elements.some((ui = {}) => {
      if (
        (ui.tagname === 'checkbox' || ui.tagname === 'checkboxInput') &&
        ui.key === key
      ) {
        checkbox = ui
        return true
      }
      if (ui.elements) {
        checkbox = findCheckbox(key, ui.elements)
        return !!checkbox
      }
      return false
    })
    return checkbox
  }

  const getCheckboxGroupParamValues = (paramData) => {
    let checkboxGroupKey = paramData.checkboxGroupKey || paramData.key
    let checkboxGroup = findCheckboxGroup(
      checkboxGroupKey,
      objectPath.get(jsonForm, 'uischema.elements') || [],
    )
    let options = checkboxGroup?.options || []
    let valueType = paramData.checkboxValueType || 'name'
    let values = []

    options.forEach((option = {}) => {
      let checkedValue = getCheckValue(option.valueChecked)
      let checkboxValue = objectPath.has(formData, option.key)
        ? objectPath.get(formData, option.key)
        : objectPath.get(formData, option.name)

      if (getCheckValue(checkboxValue) === checkedValue) {
        values.push(valueType === 'value' ? checkboxValue : option.name)
      }
    })

    return values
  }

  const getCheckboxParamValues = (paramData) => {
    let checkboxKey = paramData.checkboxKey || paramData.key
    let checkbox = findCheckbox(
      checkboxKey,
      objectPath.get(jsonForm, 'uischema.elements') || [],
    )
    if (!checkbox) return []

    let checkedValue = objectPath.has(checkbox, 'valueChecked')
      ? getCheckValue(checkbox.valueChecked)
      : true
    let checkboxValue = objectPath.has(formData, checkbox.key)
      ? objectPath.get(formData, checkbox.key)
      : objectPath.get(formData, checkbox.name)

    if (getCheckValue(checkboxValue) === checkedValue) {
      return [paramData.value || paramData.test || '']
    }
    return []
  }

  const isCheckboxGroupParam = (paramData) => {
    return (
      paramData.propType === 'checkboxGroup' ||
      !!findCheckboxGroup(
        paramData.checkboxGroupKey || paramData.key,
        objectPath.get(jsonForm, 'uischema.elements') || [],
      )
    )
  }

  const isCheckboxParam = (paramData) => {
    return paramData.propType === 'checkbox'
  }

  const isPrintConditionParam = (paramData) => {
    return isCheckboxGroupParam(paramData) || isCheckboxParam(paramData)
  }

  const getParamValue = (paramData) => {
    if (isCheckboxGroupParam(paramData)) {
      return getCheckboxGroupParamValues(paramData)
    }
    if (isCheckboxParam(paramData)) {
      return getCheckboxParamValues(paramData)
    }
    return objectPath.get(formData, paramData.key)
  }

  const setParamValue = (paramData, value) => {
    let { prefixValue = '', test = '' } = paramData
    if (value === undefined || value === null || value === '') {
      value = test
    }
    if (prefixValue) {
      value = prefixValue + value
    }
    return value
  }

  const createPrintUrl = (url, pathParams, queryParams, checkboxParamValue) => {
    if (pathParams) {
      pathParams.forEach((paramData) => {
        let { param } = paramData
        let value = getParamValue(paramData)
        if (isPrintConditionParam(paramData)) {
          value = checkboxParamValue
        }
        value = setParamValue(paramData, value)
        url = url.replace(`:${param}`, value)
      })
    }

    let queryString = []
    if (queryParams) {
      queryParams.forEach((paramData) => {
        let { param } = paramData
        let value = getParamValue(paramData)
        if (isPrintConditionParam(paramData)) {
          value = checkboxParamValue
        }
        value = setParamValue(paramData, value)
        queryString.push(`${param}=${value}`)
      })
    }
    let connect = url.indexOf('?') > -1 ? '&' : '?'
    return queryString.length > 0 ? url + connect + queryString.join('&') : url
  }

  let allParams = [...(pathParams || []), ...(queryParams || [])]
  let checkboxParam = allParams.find((paramData) =>
    isPrintConditionParam(paramData),
  )
  let checkboxParamValues = checkboxParam
    ? isCheckboxGroupParam(checkboxParam)
      ? getCheckboxGroupParamValues(checkboxParam)
      : getCheckboxParamValues(checkboxParam)
    : []

  if (checkboxParam && checkboxParamValues.length === 0) {
    return {
      status: 200,
      message: 'success',
      data: {},
    }
  }

  if (checkboxParam) {
    checkboxParamValues.forEach((checkboxParamValue) => {
      let printUrl = createPrintUrl(
        url,
        pathParams,
        queryParams,
        checkboxParamValue,
      )
      if (printUrl) {
        window.open(printUrl, '_blank')
      }
    })
  } else {
    let printUrl = createPrintUrl(url, pathParams, queryParams)
    if (printUrl) {
      window.open(printUrl, '_blank')
    }
  }
  return {
    status: 200,
    message: 'success',
    data: {},
  }
}

const resetKey = (keyList, designContext) => {
  let { jsonForm, searchData, setFormData, setSearchData } = designContext
  let formData = objectPath.get(jsonForm, 'formData')
  const mapWidgetUi = objectPath.get(jsonForm, 'schema.mapWidget.ui') || {}
  Object.keys(keyList).forEach((key) => {
    if (!key) return
    let ui = getCurrentUi(key, jsonForm.schema, jsonForm.uischema)
    objectPath.del(formData, key)
    objectPath.del(searchData, key)
    if (ui.key === key) {
      objectPath.del(formData, ui.name)
      objectPath.del(searchData, ui.name)
    } else if (mapWidgetUi[key]) {
      let { name } = mapWidgetUi[key]
      objectPath.del(formData, name)
    }
  })
  setFormData(formData)
  setSearchData(searchData)
}

export const resetData = (action, designContext) => {
  let {
    jsonForm,
    setDesignerPropsData,
    setAllData,
    setIsResetData,
    widgetDesign,
  } = designContext
  let allFormGroup = jsonForm.formGroup
  let designerPropsData = objectPath.get(jsonForm, 'designerPropsData') || {}
  let formData = objectPath.get(jsonForm, 'formData')
  let resetType = action?.resetType
  if (resetType === 'all') {
    resetKey(formData, designContext)
    objectPath.set(designerPropsData, `data`, {})
    objectPath.set(designerPropsData, `isReset`, true)
    setDesignerPropsData(designerPropsData)
    setAllData({})
    setIsResetData(true)
  } else if (resetType === 'form') {
    let formList = action?.form || []
    formList.forEach((formKey) => {
      let form = allFormGroup.find(({ key }) => key === formKey) || {}
      let {
        isGroup,
        mapDataKey = {},
        groupData = [],
        mapParam = {},
        mapArray = {},
      } = form
      let paramList = Object.keys(mapParam)

      paramList.forEach((key) => {
        let isArray = objectPath.get(mapArray, key)
        if (isArray) {
          let ui = getCurrentUi(key)
          if (ui.key === key) {
            let { elements = [] } = ui
            elements.forEach((mainElement) => {
              let name = mainElement.name
              if (mainElement.tagname === 'panel') {
                name = '@' + name
              }
              objectPath.del(formData, name)
              objectPath.del(formData, `@isCheckedAll.${name}`)
            })
          }
        }
      })
      if (isGroup) {
        groupData.forEach(({ mapDataKey }) => {
          resetKey(mapDataKey, designContext)
        })
      } else {
        resetKey(mapDataKey, designContext)
      }
    })
  }
  return {
    status: 200,
    message: '',
    data: formData,
  }
}

export const callAction = (name, action, designContext, data, routerDom) => {
  switch (name) {
    case 'goToForm':
      return goToForm(action, designContext, routerDom)
    case 'goToPage':
      return goToPage(action, designContext, routerDom)
    case 'goToUrl':
      return goToUrl(action, designContext, data)
    case 'openModal':
      return openModal(action, designContext, data)
    case 'closeModal':
      return closeModal(action, designContext, data)
    case 'refreshTable':
      return refreshTable(action, designContext, data)
    case 'print':
      return print(action, designContext)
    default:
      return
  }
}

export const handleEnterAction = (ev, uischema, designContext, config = {}) => {
  let onEnterName = objectPath.get(uischema, 'onEnter.name')
  if (onEnterName) {
    checkOnEnter(ev, uischema, designContext)
    if (onEnterName === 'nextInput') return
  }

  handleEnterToNextInput(ev, config)
}

export const checkOnEnter = (ev, uischema, designContext) => {
  let { jsonForm, isUiChanged, setIsUiChanged } = designContext
  let { onEnter = {} } = uischema
  let { name } = onEnter
  if (!name) return
  if (name === 'refButton') {
    let action = objectPath.get(onEnter, name)
    let refButtonKey = action?.key
    let refButtonUi = getCurrentUi(
      refButtonKey,
      jsonForm.schema,
      jsonForm.uischema,
    )
    objectPath.set(isUiChanged, ['enterRefAction', refButtonKey], refButtonUi)
    setIsUiChanged(isUiChanged)
  } else if (name === 'nextInput') {
    focusNextInput(ev)
  }
}

export const handleEnterToNextInput = (ev, config = {}) => {
  if (!isEnterToTab(config)) return
  if (ev?.key !== 'Enter') return
  if (ev?.nativeEvent?.isComposing || ev?.isComposing) return
  if (!isInputTarget(ev?.target)) return
  if (focusNextInput(ev)) {
    ev.preventDefault()
    ev.stopPropagation()
  }
}

const isEnterToTab = (config = {}) => {
  if (config?.enterToTab) return true
  if (typeof window === 'undefined') return false
  const path = window.location?.hash || window.location?.pathname || ''
  return path.includes('/display/form/')
}

const isInputTarget = (target) => {
  if (!target || typeof target.matches !== 'function') return false
  if (isButtonElement(target)) return false
  if (target.tagName?.toLowerCase() === 'textarea') return false
  return target.matches(
    'input:not([type="hidden"]), select, [tabindex]:not([tabindex="-1"])',
  )
}

const isButtonElement = (element) => {
  const tagName = element?.tagName?.toLowerCase()
  const type = element?.getAttribute?.('type')
  return (
    tagName === 'button' ||
    type === 'button' ||
    type === 'submit' ||
    type === 'reset'
  )
}

const isHiddenElement = (element) => {
  if (typeof window === 'undefined') return false
  const style = window.getComputedStyle(element)
  const rect = element.getBoundingClientRect()
  return (
    style.display === 'none' ||
    style.visibility === 'hidden' ||
    rect.width === 0 ||
    rect.height === 0
  )
}

const focusNextInput = (ev) => {
  const currentTarget = ev?.target
  if (!currentTarget || typeof currentTarget.closest !== 'function') return
  const formContainer = currentTarget.closest('form')
  if (!formContainer) return
  const focusableElements = Array.from(
    formContainer.querySelectorAll(
      'input:not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])',
    ),
  ).filter((element) => {
    const isDisabled = element.disabled
    const isReadOnly = element.readOnly
    const isAriaDisabled = element.getAttribute('aria-disabled') === 'true'
    const isHidden = isHiddenElement(element)
    return (
      !isButtonElement(element) &&
      !isDisabled &&
      !isReadOnly &&
      !isAriaDisabled &&
      !isHidden
    )
  })
  const currentIndex = focusableElements.indexOf(currentTarget)
  if (currentIndex === -1) return
  const nextElement = focusableElements[currentIndex + 1]
  if (nextElement && typeof nextElement.focus === 'function') {
    nextElement.focus()
    return true
  }
}
